import { styled } from 'styled-components'

export interface LineItemContainerProps {
  isPadded?: boolean
}

export const LineItemContainer = styled.article<LineItemContainerProps>`
  display: flex;
  justify-content: space-between;
  padding-left: ${({ isPadded }) => (isPadded ? '28px' : '0')};
`
